/**
 * ProgressBar — barra de progresso reutilizável (hash e upload). Acessível.
 */

export interface ProgressBarProps {
  readonly feitos: number;
  readonly total: number;
  readonly rotulo: string;
}

export function ProgressBar({ feitos, total, rotulo }: ProgressBarProps): JSX.Element {
  const pct = total > 0 ? Math.round((feitos / total) * 100) : 0;
  return (
    <div>
      <p className="muted" style={{ margin: '0 0 6px' }}>
        {rotulo} — {feitos}/{total} ({pct}%)
      </p>
      <div
        className="progress"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <span style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
